import React, { useState } from "react";
import "./SiteCrews.css";

const crewImgCarpentry = require("../../assets/pranav-khot-house/WhatsApp Image 2026-08-27 at 4.51.44 PM.jpeg");
const crewImgCivil = require("../../assets/specialist-img/ChatGPT Image Sep 12, 2026, 05_12_07 PM.png");
const crewImgCeiling = require("../../assets/pranav-khot-house/WhatsApp Image 2026-08-27 at 4.03.57 PM.jpeg");
const crewImgPainting = require("../../assets/specialist-img/coloring.png");
const crewImgElectrical = require("../../assets/specialist-img/electrics.png");
const crewImgInteriorDesign = require("../../assets/interior-work.jpeg");

const siteCrews = [
  {
    n: "01",
    title: "Site Carpentry",
    desc: "Panelling, cladding, door frames and on-site joinery - scribed to the walls you actually have.",
    items: ["Ply & veneer panelling", "Lofts & storage", "Door & frame work"],
    img: crewImgCarpentry,
  },
  {
    n: "02",
    title: "Interior Design",
    desc: "Spaces planned and styled end-to-end, from layout to finish, matched to how you actually live.",
    items: ["Space planning", "Material & finish selection", "Furniture & decor styling"],
    img: crewImgInteriorDesign,
  },
  {
    n: "03",
    title: "POP & False Ceiling",
    desc: "Ceilings, cornices and cove pockets set out with the lighting plan, not after it.",
    items: ["False ceilings", "Cove lighting pockets", "Cornice detailing"],
    img: crewImgCeiling,
  },
  {
    n: "04",
    title: "Painting & Finishes",
    desc: "Putty, primer and finish coats checked under site light and again at handover.",
    items: ["Putty & primer", "Emulsion & texture", "Touch-up at handover"],
    img: crewImgPainting,
  },
  {
    n: "05",
    title: "Electrical & Lighting",
    desc: "Point shifting, circuit loads and fixture placement planned for every room.",
    items: ["Point shifting", "Load balancing", "Fixture placement"],
    img: crewImgElectrical,
  },
  {
    n: "06",
    title: "Civil Work",
    desc: "Wall changes, plaster, levelling and bathroom waterproofing done before finishes begin.",
    items: ["Breaking & masonry", "Waterproofing", "Flooring & levels"],
    img: crewImgCivil,
  },
];

export default function SiteCrews({
  eyebrow = "What we take care of on site",
  title = "Execution by Dwellora",
  description = "Done by Dwellora's own team",
}) {
  const [activeCrewIndex, setActiveCrewIndex] = useState(-1);

  const toggleCrew = (index) => {
    setActiveCrewIndex((prev) => (prev === index ? -1 : index));
  };

  const openContactModal = () => {
    window.dispatchEvent(new CustomEvent("dwellora:open-contact"));
  };

  return (
    <section className="dw-site-crews dw-section--card">
      <div className="dw-section">
        <p className="dw-eyebrow">{eyebrow}</p>
        <h2 className="dw-section-title" style={{ maxWidth: "42rem", marginTop: 0 }}>
          {title}
        </h2>
        <p className="dw-section-desc">{description}</p>

        <div className="dw-crew-grid">
          {siteCrews.map((crew, index) => (
            <button
              type="button"
              key={crew.n}
              className={`dw-crew-tile${index === activeCrewIndex ? " is-active" : ""}`}
              onClick={() => toggleCrew(index)}
              aria-expanded={index === activeCrewIndex}
            >
              <img src={crew.img} alt={crew.title} loading="lazy" />
              <div className="dw-crew-tile-overlay" />

              <div className="dw-crew-tile-content">
                <span className="dw-crew-tile-num">{crew.n}</span>
                <h3 className="dw-crew-tile-title">{crew.title}</h3>

                <div className="dw-crew-tile-detail">
                  <div className="dw-crew-tile-detail-inner">
                    <p className="dw-crew-tile-desc">{crew.desc}</p>
                    <ul className="dw-crew-tile-list">
                      {crew.items.map((item) => (
                        <li key={item}>
                          <span className="dw-crew-dot" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="dw-crew-cta">
          <button type="button" className="dw-crew-cta-button" onClick={openContactModal}>
            Talk to a Designer
          </button>
        </div>
      </div>
    </section>
  );
}
